var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73617 2.78435L9.95445 5.21818C10.0738 5.45711 10.3043 5.62279 10.5716 5.66113L13.2969 6.05342C13.9702 6.15063 14.2382 6.9667 13.7509 7.4343L11.7801 9.32797C11.5864 9.51419 11.4983 9.78187 11.5441 10.0448L12.0092 12.7182C12.1237 13.3796 11.4198 13.8841 10.818 13.5713L8.38214 12.3081C8.14335 12.1842 7.85735 12.1842 7.61786 12.3081L5.182 13.5713C4.58015 13.8841 3.87626 13.3796 3.9915 12.7182L4.4559 10.0448C4.50171 9.78187 4.41355 9.51419 4.21988 9.32797L2.24912 7.4343C1.76181 6.9667 2.02976 6.15063 2.70311 6.05342L5.42843 5.66113C5.69569 5.62279 5.92685 5.45711 6.04625 5.21818L7.26383 2.78435C7.5651 2.18256 8.4349 2.18256 8.73617 2.78435Z",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.ef3428455af414f79e4de139583c3e56.svg";
export { ForwardRef as ReactComponent };